import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography } from "@mui/material";
import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import BlockIcon from "@mui/icons-material/Block";
import { colors } from "../components/Theme/WebTheme";
import moment from "moment/min/moment-with-locales";
import { downloadCsv } from "../common/sharedFunctions";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function CarsList() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const userdata = useSelector((state) => state.usersdata);
  const auth = useSelector((state) => state.auth);
  const [drivers, setDrivers] = useState([]);
  const { updateUserCar, editCar } = api;
  const [driversObj, setDriversObj] = useState();
  const [fleetMapObj, setFleetMapObj] = useState([]);
  const [data, setData] = useState([]);
  const cartypes = useSelector((state) => state.cartypes);
  const carlistdata = useSelector((state) => state.carlistdata);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin")
      );
      let obj = {};
      let obj2 = {};
      let arr2 = [];
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        arr2.push({
          id: user.id,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : "Hidden"),
        });
        obj[user.id] =
          user.firstName +
          " " +
          user.lastName +
          " (" +
          (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
          ") " +
          (settings.AllowCriticalEditsAdmin ? user.email : "Hidden");
        obj2[user.id] = user.fleetadmin ? user.fleetadmin : null;
      }
      setDrivers(arr2);
      setDriversObj(obj);
      setFleetMapObj(obj2);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid,
  ]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata.cars) {
      setData(carlistdata.cars);
    } else {
      setData([]);
    }
  }, [carlistdata.cars]);

  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if (selectedImage) {
      setLoading(true);
      let finalData = userData;
      finalData.car_image = selectedImage;
      dispatch(editCar(finalData, "UpdateImage"));
      setProfileModal(false);
      setTimeout(() => {
        setSelectedImage(null);
        setLoading(false);
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
  };

  const onClick = (rowData) => {
    setImageData(rowData.car_image);
    setProfileModal(true);
    setUserData(rowData);
  };

  const [category, setCategory] = useState([]);
  const [categoryObj, setCategoryObj] = useState(null);
  const [carType, setCarType] = useState([]);
  const [carTypeObj, setCarTypeObj] = useState(null);

  const [selectCategory, setSelectCategory] = useState(null);
  const [driver, setDriver] = useState(null);
  const [selectCartype, setSelectCartype] = useState(null);

  const handelchangeCategory = (event, newValue) => {
    setSelectCategory(newValue);
    setSelectCartype();
    if (cartypes.cars) {
      let arr = [];
      for (let i = 0; i < cartypes.cars.length; i++) {
        if (newValue) {
          if (newValue.value === cartypes.cars[i].category) {
            arr.push({
              label: t(cartypes.cars[i].name),
              value: cartypes.cars[i].name,
            });
          }
        } else {
          setCarType([]);
        }
      }
      setCarType(arr);
    }
  };

  const handelchangeDriver = (event, newValue) => {
    setDriver(newValue);
  };

  const handelchangeCartype = (event, newValue) => {
    setSelectCartype(newValue);
  };

  useEffect(() => {
    if (cartypes.cars) {
      let arr = [];
      for (let i = 0; i < cartypes.cars.length; i++) {
        arr.push({
          label: t(cartypes.cars[i].category),
          value: cartypes.cars[i].category,
        });
      }
      let newArray = [];
      let uniqueObject = {};
      for (let i in arr) {
        let objTitle = arr[i]["label"];
        uniqueObject[objTitle] = arr[i];
      }
      for (let i in uniqueObject) {
        newArray.push(uniqueObject[i]);
      }
      setCategory(newArray);
    }
  }, [cartypes.cars, t]);

  useEffect(() => {
    if (cartypes.cars) {
      setCategoryObj(
        cartypes.cars[0] && cartypes.cars[0].category
          ? cartypes.cars[0].category
          : null
      );
    }
  }, [cartypes.cars]);

  useEffect(() => {
    if (cartypes.cars) {
      setCarTypeObj(
        cartypes.cars[0] && cartypes.cars[0].name ? cartypes.cars[0].name : null
      );
    }
  }, [cartypes.cars]);

  const columns = [
    {
      title: t("createdAt"),
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.createdAt ? moment(rowData.createdAt).format("lll") : null,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("driver"),
      field: "driver",
      editable: "onAdd",
      cellStyle: { textAlign: "center" },
      render: (rowData) => {
        if (rowData && rowData.driver) {
          return driversObj && driversObj[rowData.driver]
            ? driversObj[rowData.driver]
            : null;
        }
      },
      editComponent: (props) => (
        <Autocomplete
          id="combo-box-demo"
          options={drivers}
          getOptionLabel={(option) => option.desc}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Combo box" variant="outlined" />
          )}
          onChange={handelchangeDriver}
          disableClearable={true}
          value={driver}
        />
      ),
      exportTransformer: (rowData) => driversObj[rowData.driver],
      hidden: role === "driver" ? true : false,
    },

    {
      title: t("category"),
      field: "category",
      cellStyle: { textAlign: "center" },
      render: (rowData) => {
        if (rowData && rowData.category) {
          return t(rowData.category);
        }
      },
      editComponent: (props) => (
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={category}
          sx={{ width: 200 }}
          renderInput={(params) => (
            <TextField {...params} label={t("category")} />
          )}
          onChange={handelchangeCategory}
          disableClearable={true}
          value={selectCategory}
        />
      ),
      exportTransformer: (rowData) =>
        rowData.category ? t(rowData.category) : categoryObj[rowData.category],
      editable: "onAdd",
    },

    {
      title: t("carType"),
      field: "carType",
      cellStyle: { textAlign: "center" },
      render: (rowData) => {
        if (rowData && rowData.carType) {
          return t(rowData.carType);
        }
      },
      editComponent: (props) => (
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={carType}
          sx={{ width: 200 }}
          renderInput={(params) => (
            <TextField {...params} label={t("carType")} />
          )}
          onChange={handelchangeCartype}
          disableClearable={true}
          value={selectCartype}
        />
      ),
      exportTransformer: (rowData) => carTypeObj[rowData.carType],
      editable: "onAdd",
    },
    { title: t("vehicle_reg_no"), field: "vehicleNumber" },
    { title: t("vehicle_model_name"), field: "vehicleMake" },
    { title: t("vehicle_model_no"), field: "vehicleModel" },
    { title: t("other_info"), field: "other_info" },
    {
      title: t("image"),
      field: "car_image",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.car_image ? (
          <button
            onClick={() => {
              onClick(rowData);
            }}
          >
            <img alt="CarImage" src={rowData.car_image} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("active_status"),
      field: "active",
      editable: role === "admin" ? "never" : "always",
      type: "boolean",
    },
    {
      title: t("approved"),
      field: "approved",
      editable: role === "admin" ? "always" : "never",
      type: "boolean",
    },
  ];

  const [selectedRow, setSelectedRow] = useState(null);

  return carlistdata.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
      <MaterialTable
        title={t("cars")}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          boxShadow: "4px 4px 6px #9E9E9E",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          exportCsv: (columns, data) => {
            let hArray = [];
            const headerRow = columns.map((col) => {
              if (typeof col.title === "object") {
                return col.title.props.text;
              }
              hArray.push(col.field);
              return col.title;
            });
            const dataRows = data.map(({ tableData, ...row }) => {
              row.createdAt = row.createdAt
                ? new Date(row.createdAt).toLocaleDateString() +
                  " " +
                  new Date(row.createdAt).toLocaleTimeString()
                : "";
              let dArr = [];
              for (let i = 0; i < hArray.length; i++) {
                dArr.push(row[hArray[i]]);
              }
              return Object.values(dArr);
            });
            const { exportDelimiter } = ",";
            const delimiter = exportDelimiter ? exportDelimiter : ",";
            const csvContent = [headerRow, ...dataRows]
              .map((e) => e.join(delimiter))
              .join("\n");
            const csvFileName = "cars.csv";
            downloadCsv(csvContent, csvFileName);
          },
          exportButton: {
            csv: settings.AllowCriticalEditsAdmin,
            pdf: false,
          },
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id
                ? colors.THIRDCOLOR
                : colors.WHITE,
          }),
          editable: {
            backgroundColor: colors.WHITE,
            fontSize: "0.8em",
            fontWeight: "bold ",
            fontFamily: 'Lucida Console", "Courier New", monospace',
          },
          cellStyle: { textAlign: "center" },
          headerStyle: {
            position: "sticky",
            textAlign: "center",
            top: "0px",
            backgroundColor: colors.SECONDARY,
            color: colors.WHITE,
            fontSize: "0.8em",
            fontWeight: "bold ",
            fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        localization={{
          body: {
            addTooltip: t("add"),
            deleteTooltip: t("delete"),
            editTooltip: t("edit"),
            emptyDataSourceMessage: t("blank_message"),
            editRow: {
              deleteText: t("delete_message"),
              cancelTooltip: t("cancel"),
              saveTooltip: t("save"),
            },
          },
          toolbar: {
            searchPlaceholder: t("search"),
            exportTitle: t("export"),
          },
          header: {
            actions: t("actions"),
          },
          pagination: {
            labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
            firstTooltip: t("first_page_tooltip"),
            previousTooltip: t("previous_page_tooltip"),
            nextTooltip: t("next_page_tooltip"),
            lastTooltip: t("last_page_tooltip"),
          },
        }}
        editable={{
          onRowAdd: (newData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve, reject) => {
                  setTimeout(() => {
                    if (
                      newData &&
                      selectCartype.value &&
                      selectCategory.value &&
                      newData.vehicleNumber &&
                      newData.vehicleMake &&
                      newData.vehicleModel &&
                      newData.other_info &&
                      newData.car_image
                    ) {
                      let selectDriver =
                        role === "admin" || role === "fleetadmin"
                          ? driver.id
                          : auth.profile.uid;
                      let activeCar = null;
                      let updateData = {
                        carType: selectCartype.value,
                        category: selectCategory.value,
                        vehicleNumber: newData.vehicleNumber,
                        vehicleMake: newData.vehicleMake,
                        vehicleModel: newData.vehicleModel,
                        other_info: newData.other_info,
                        car_image: newData.car_image,
                        createdAt: new Date().getTime(),
                        driver: selectDriver,
                      };
                      for (let i = 0; i < data.length; i++) {
                        if (data[i].driver === selectDriver && data[i].active) {
                          activeCar = data[i];
                          break;
                        }
                      }
                      if (activeCar && newData.active) {
                        activeCar.active = false;
                        dispatch(editCar(activeCar, "Update"));
                        dispatch(updateUserCar(selectDriver, updateData));
                      } else if (activeCar && !newData.active) {
                        newData.active = false;
                      } else {
                        newData.active = true;
                        dispatch(updateUserCar(selectDriver, updateData));
                      }
                      if (role === "driver") {
                        newData["driver"] = selectDriver;
                      }
                      newData["createdAt"] = new Date().getTime();
                      newData["fleetadmin"] = newData["driver"]
                        ? fleetMapObj[newData["driver"]]
                          ? fleetMapObj[newData["driver"]]
                          : null
                        : null;
                      if (!settings.carApproval) {
                        newData["approved"] = true;
                        if (newData.active) {
                          dispatch(
                            updateUserCar(selectDriver, { carApproved: true })
                          );
                        }
                      } else {
                        newData["approved"] = false;
                      }
                      let updateCaeData = {
                        ...updateData,
                        active: newData.active,
                        approved: newData.approved,
                        fleetadmin:
                          role === "fleetadmin" ? auth.profile.uid : null,
                      };
                      dispatch(editCar(updateCaeData, "Add"));
                      setSelectCategory();
                      setDriver();
                      setSelectCartype();
                      resolve();
                    } else {
                      alert(t("proper_input_name"));
                      reject();
                    }
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
          onRowUpdate: (newData, oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    if (newData !== oldData) {
                      let activeCar = null;
                      let updateData = {
                        carType: newData.carType,
                        category: newData.category,
                        vehicleNumber: newData.vehicleNumber,
                        vehicleMake: newData.vehicleMake,
                        vehicleModel: newData.vehicleModel,
                        other_info: newData.other_info,
                        car_image: newData.car_image,
                        updateAt: new Date().getTime(),
                      };
                      for (let i = 0; i < data.length; i++) {
                        if (
                          data[i].driver === newData.driver &&
                          data[i].active
                        ) {
                          activeCar = data[i];
                          break;
                        }
                      }
                      if (activeCar && newData.active) {
                        activeCar.active = false;
                        dispatch(editCar(activeCar, "Update"));
                        dispatch(updateUserCar(newData.driver, updateData));
                      } else if (activeCar && !newData.active) {
                        newData.active = false;
                      } else {
                        newData.active = true;
                        dispatch(updateUserCar(newData.driver, updateData));
                      }
                      newData["fleetadmin"] = newData["fleetadmin"]
                        ? fleetMapObj[newData["driver"]]
                        : null;
                      delete newData.tableData;
                      dispatch(editCar(newData, "Update"));
                      if (newData.driver !== oldData.driver && oldData.driver) {
                        dispatch(
                          updateUserCar(oldData.driver, {
                            carType: null,
                            vehicleNumber: null,
                            vehicleMake: null,
                            vehicleModel: null,
                            other_info: null,
                            car_image: null,
                            updateAt: new Date().getTime(),
                          })
                        );
                      }
                    }
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve, reject) => {
                  setTimeout(() => {
                    if (oldData.active) {
                      reject();
                      alert(t("active_car_delete"));
                    } else {
                      resolve();
                      dispatch(editCar(oldData, "Delete"));
                    }
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
        actions={[
          (rowData) =>
            settings.carApproval && role === "admin"
              ? {
                  icon: () =>
                    rowData.approved ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <BlockIcon />
                        <Typography variant="subtitle2">
                          {t("reject")}
                        </Typography>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <DoneAllIcon />
                        <Typography variant="subtitle2">
                          {t("accept")}
                        </Typography>
                      </div>
                    ),
                  onClick: (event, rowData) => {
                    if (rowData.active) {
                      dispatch(
                        updateUserCar(rowData.driver, {
                          carApproved: !rowData.approved,
                        })
                      );
                    }
                    dispatch(
                      editCar(
                        { ...rowData, approved: !rowData.approved },
                        "Update"
                      )
                    );
                  },
                }
              : null,
        ]}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
              {t("car_image")}
              <input
                type="file"
                style={{ marginLeft: 10 }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage && !loading ? (
              <Tooltip title={t("cancel")}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{
                    fontSize: 30,
                    backgroundColor: colors.RED,
                    borderRadius: 50,
                    color: colors.WHITE,
                  }}
                />
              </Tooltip>
            ) : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage ? (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={URL.createObjectURL(selectedImage)}
                style={{ marginTop: 15, marginBottom: 20 }}
              />
            ) : (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={imageData}
                style={{ marginTop: 10 }}
              />
            )}
            <br />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={handleProfileModal}
                  variant="contained"
                  color="danger"
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={handleSetProfileModal}
                  variant="contained"
                  color="success"
                  style={{ marginLeft: 10 }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
